export enum FeedbackSource {
  PROFILE = "Profile Screen",
  PROMPT = "Review Prompt",
  ROUTINE = "Routine Feedback",
  ROUTINE_DAY = "Message for routine creator",
  FIND_FRIEND = "Add Friend Widget: Find an accountability buddy",
}
